/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The calculation runs entirely in your browser; nothing is uploaded.`)
};

const es_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El cálculo se ejecuta completamente en su navegador; no se carga nada.`)
};

const de_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Berechnung erfolgt vollständig in Ihrem Browser; es werden keine Daten hochgeladen.`)
};

const nl_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De berekening wordt volledig in uw browser uitgevoerd; niets wordt geüpload.`)
};

const fr_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le calcul s'exécute entièrement dans votre navigateur; rien n'est téléchargé.`)
};

const it_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Il calcolo viene eseguito interamente nel tuo browser; nulla viene caricato.`)
};

const pt_br2_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O cálculo é executado inteiramente no seu navegador; nada é enviado.`)
};

const pt_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. O cálculo funciona inteiramente no seu navegador; nada é enviado.`)
};

const ja_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「いいえ。計算はブラウザで完全に実行されます。何もアップロードされません。」`)
};

const zh_ln_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。计算完全在您的浏览器中进行，不会上传任何数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_faq3_a", locale)
	if (locale === "en") return en_ln_faq3_a(inputs)
	if (locale === "es") return es_ln_faq3_a(inputs)
	if (locale === "de") return de_ln_faq3_a(inputs)
	if (locale === "nl") return nl_ln_faq3_a(inputs)
	if (locale === "fr") return fr_ln_faq3_a(inputs)
	if (locale === "it") return it_ln_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_ln_faq3_a(inputs)
	if (locale === "pt") return pt_ln_faq3_a(inputs)
	if (locale === "ja") return ja_ln_faq3_a(inputs)
	return zh_ln_faq3_a(inputs)
};